import React from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

export class AppErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: unknown) {
    if (import.meta.env.DEV) {
      console.error('[AppErrorBoundary] Caught error', error, info);
    }
    // TODO: integrate remote logging (e.g., Sentry) if desired.
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center p-6 text-center">
          <div>
            <h1 className="text-2xl font-semibold mb-2">حدث خطأ غير متوقع</h1>
            <p className="opacity-70">جرّب تحديث الصفحة. إذا استمرت المشكلة، تواصل مع الدعم.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default AppErrorBoundary;
